import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";

import { classNames } from "@/utils/classNames";

/**
 * Inline "See work history / See more ⌄" expander link used by the identity
 * cards (person + company headers). Renders at the end of the location line and
 * flips to "Hide" with a rotated chevron once expanded. Plain Tailwind, no
 * portals — safe inside the Chrome extension's shadow root.
 */
export const ExpandToggle: FunctionComponent<{
	expanded: boolean;
	/** i18n key of the collapsed-state label (e.g. "…identity.seeWorkHistory"). */
	showLabelKey: string;
	onToggle: () => void;
}> = ({ expanded, showLabelKey, onToggle }) => {
	const { t } = useTranslation();

	return (
		<button
			className="flex shrink-0 cursor-pointer flex-row items-center gap-1 whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-semibold text-blue-action transition-colors duration-200 hover:bg-blue-action-200"
			type="button"
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				onToggle();
			}}
		>
			{expanded ? t("contacts.leadPanel.identity.hide") : t(showLabelKey)}
			<Icon
				className={classNames(
					"h-2.5 w-2.5 transition-transform duration-200",
					expanded ? "rotate-180" : ""
				)}
				icon={faChevronDown}
			/>
		</button>
	);
};
